/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, MailOutline, MapsHomeWorkOutlined, WhatsApp} from "@mui/icons-material";


const Formulario_Datos = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellido'} dato={'apellido'} {...props}
                                  requerido={'El Apellido es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'El Correo es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Ciudad Residencia'} dato={'ciudad'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14, fontWeight: 400}}>Te harémos llegar mas detalles de la
                        reunion</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WhatsApp} nombre={'Num Celular (WhatsApp)'} dato={'celular'} {...props}
                                  requerido={'El WhatsApp es nuestro medio de comunicacion mas directo'}
                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Datos